/* AT2 EXPERIMENT - Sending Modal */

/**
 * Modal affiché quand l'analyse AT2 détermine que le message est OK (needsOptimization = false)
 * et qu'il est en cours d'envoi.
 *
 * Ce modal informe l'utilisateur que son message a été validé et est en cours d'envoi.
 */

import { Box, Typography } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

import { CheckCircle } from '@evaneos/b2b-ui/icons';

import type { AT2Mode } from '../hook/useAT2MessageCheck';

import { AT2GradientModalDialog } from './shared/AT2GradientModalDialog';

type Props = {
    open: boolean;
    mode: AT2Mode;
};

export function AT2_SendingModal({ open, mode }: Props) {
    const { formatMessage } = useIntl();

    const statusMessage =
        mode === 'schedule'
            ? formatMessage({ id: 'dossier.discussion.at2.modal.sending.status.scheduled' })
            : formatMessage({ id: 'dossier.discussion.at2.modal.sending.status.sent' });

    return (
        <AT2GradientModalDialog open={open}>
            <Typography variant="h4" color="white" align="left" sx={{ width: '100%', mb: 5 }}>
                {formatMessage({ id: 'dossier.discussion.at2.modal.sending.title' })}
            </Typography>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={1}
                sx={{ width: '100%', px: 6, mb: 8 }}
            >
                <CheckCircle sx={{ color: '#bfe4ad' }} />
                <Typography variant="h5" color="white">
                    {statusMessage}
                </Typography>
            </Box>
        </AT2GradientModalDialog>
    );
}
